import { Cohort } from '@platform/client/schemas';
import { PillBadge } from '@platform/components';

export const ProCohortAvailabilityText = ({ cohort }: { cohort: Cohort }) => {
  const { startDate, endDate, duration, timeCommitment } = cohort;
  if (!startDate || !endDate) {
    return null;
  }
  return (
    <p>
      <CohortDatesPillSpan startDate={startDate} endDate={endDate} />
      {duration && <CohortDurationSpan duration={duration} />}
      {timeCommitment && <CohortTimeCommitmentSpan timeCommitment={timeCommitment} />}
    </p>
  );
};

const CohortDatesPillSpan = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  const formattedDateString = `${formatDateStrShort(startDate)} - ${formatDateStrShort(endDate)}`;
  return (
    <>
      <span>📆 Available between&nbsp;</span>
      <PillBadge variant='plain' color='orange' size='md'>
        {formattedDateString}
      </PillBadge>
    </>
  );
};

const CohortDurationSpan = ({ duration }: { duration: string }) => {
  return (
    <>
      <span>&nbsp;for projects up to&nbsp;</span>
      <PillBadge variant='plain' color='success-25' size='md'>
        {duration}
      </PillBadge>
    </>
  );
};

const CohortTimeCommitmentSpan = ({ timeCommitment }: { timeCommitment: string }) => {
  return (
    <>
      <span>&nbsp;and can dedicate about&nbsp;</span>
      <PillBadge variant='plain' color='blue' size='md'>
        {timeCommitment}
      </PillBadge>
    </>
  );
};

const formatDateStrShort = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-CA', {
    month: 'short',
    day: 'numeric',
  });
};
